import rest from "../axiosRestCalls";
import {API_BASE_PATH} from "../restConstants";

class tireOfferService{
    getCurrent(){
        return rest.get(API_BASE_PATH + 'tireOffer/current');
    }
    getBrand(brand){
        return rest.get(API_BASE_PATH + 'tireOffer/' + brand);
    }
}
// eslint-disable-next-line
export default new tireOfferService();
